qw-calendar {
  max-width: 1094px;
  width: 100%;
  display: block;
}

@media only screen and (min-width: 738px) and (min-height: 760px) {
  qw-calendar {
    min-width: 700px;
  }
}

@media only screen and (min-width: 975px) and (min-height: 760px) {
  qw-calendar {
    min-width: 870px;
  }
}

@media only screen and (min-width: 1100px) and (min-height: 760px) {
  qw-calendar {
    min-width: 970px;
  }
}

@media only screen and (min-width: 1280px) and (min-height: 760px) {
  qw-calendar {
    min-width: 1094px;
  }
}

@media only screen and (min-height: 759px) {
  qw-calendar qw-calendar-picker {
    min-height: 498px;
  }
}

/* Heights to avoid months jumping */
@media only screen and (max-width: 1280px) and (min-height: 759px) {
  qw-calendar qw-calendar-picker {
    min-height: 501px;
  }
}
@media only screen and (max-width: 1110px) and (min-height: 759px) {
  qw-calendar qw-calendar-picker {
    min-height: 507px;
  }
}
@media only screen and (max-width: 975px) and (min-height: 759px) {
  qw-calendar qw-calendar-picker {
    min-height: 405px;
  }
}

@media only screen and (max-width: 738px) and (min-height: 759px) {
  qw-calendar qw-calendar-picker {
    min-height: 400px;
  }
}

@media only screen and (max-width: 400px) {
  qw-calendar qw-calendar-picker {
    min-height: 0;
  }
}

qw-calendar-picker {
  display: flex;
  justify-content: center;
  padding: 0;
}

qw-calendar-picker.qw-calendar-picker--disabled,
qw-calendar-picker.qw-calendar-picker--disable-start-date
  .flatpickr-day.selected.startRange {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

.flatpickr-day.today {
  border: none;
}

/* classi che sovrascrivono flatpickr.min.css*/

qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.prevMonthDay.hidden {
  visibility: visible;
  color: rgba(57, 57, 57, 0.1);
  cursor: not-allowed;
  pointer-events: none;
}

qw-calendar-picker .flatpickr-innerContainer {
  align-items: flex-start;
}

qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.endRange,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.inRange,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.startRange,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.endRange:hover,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.inRange:hover,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden.selected.startRange:hover,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.nextMonthDay.hidden:hover,
qw-calendar-picker
  .flatpickr-calendar.inline
  .flatpickr-day.prevMonthDay.hidden:hover {
  background: var(--qw-hotel-primary-color) !important;
  border-color: var(--qw-hotel-primary-color) !important;
}

/* qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.selected.startRange,
qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.selected.endRange {
  background: transparent !important;
	border-color: transparent !important;
} */

/* qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.selected.startRange:after,
qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.selected.endRange:after,
qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.selected.endRange:before,
qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay.hidden.inRange:after {
  background-color: transparent !important;
} */

qw-calendar-picker .flatpickr-calendar.inline {
  top: 0;
}

qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar,
qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-rContainer,
qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-days {
  width: 100% !important;
  max-width: 100% !important;
}

qw-calendar-picker.qw-calendar-picker--responsive .dayContainer {
  width: 100%;
  min-width: inherit;
  max-width: inherit;
}

qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-day {
  max-width: inherit;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.flatpickr-disabled:hover {
  background: transparent;
  border-color: transparent;
}
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.flatpickr-disabled {
  color: rgba(57, 57, 57, 0.1);
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day:hover {
  background: #fffaae;
  border-color: #fffaae;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day {
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  font-size: 16px;
  width: 44px;
  flex-basis: 44px;
  height: 44px;
  line-height: 44px;
  margin: 10px 15px;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.inRange {
  background: none;
  border-color: transparent;
  box-shadow: none;
  position: relative;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.inRange:after {
  content: '';
  display: inline-block;
  width: calc(100% + 32px);
  height: 100%;
  position: absolute;
  top: 0px;
  left: -16px;
  background: #fffaae;
  z-index: -1;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  .flatpickr-day.startRange:after {
  content: '';
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 50%;
  background: #fffaae;
  z-index: -1;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  .flatpickr-day.endRange:before {
  content: '';
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 50%;
  background: #fffaae;
  z-index: -1;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.startRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.selected,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.selected:hover,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.endRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar
  span.flatpickr-day.endRange:hover {
  background: var(--qw-hotel-primary-color);
  border-color: var(--qw-hotel-primary-color);
}

qw-calendar-picker.qw-calendar-picker--disabled,
qw-calendar-picker.qw-calendar-picker--disable-start-date
  .flatpickr-day.selected.startRange {
  opacity: 1;
}

qw-calendar-picker.qw-calendar-picker--responsive span.flatpickr-weekday {
  font-family: var(--qw-hotel-font-family-b);
  color: var(--qw-hotel-neutral-medium);
  font-size: 16px;
  text-transform: uppercase;
}

qw-calendar-picker.qw-calendar-picker--responsive .dayContainer {
  justify-content: flex-start;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-weekdays
  .flatpickr-weekdaycontainer {
  width: 50%;
}

.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)) {
  box-shadow: var(--qw-hotel-primary-color) !important;
}

qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar {
  padding: 20px 26px 10px;
  border-radius: 5px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.26);
  border: solid 2px #414445;
  background-color: #ffffff;
}

qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-current-month {
  padding-top: 0;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-month {
  font-family: var(--qw-hotel-font-family-b);
  color: var(--qw-hotel-neutral-medium);
  font-size: 20px;
  margin-bottom: 18px;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-prev-month
  svg,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-next-month
  svg {
  display: none;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-prev-month,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-next-month {
  top: 30px;
  padding: 0;
  width: 31px;
  height: 31px;
}
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-prev-month {
  left: 30px;
}
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-next-month {
  right: 30px;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-prev-month:after,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-next-month:after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-position: center center;
  background-repeat: no-repeat;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-prev-month:after {
  background-image: url('#{$base-url}img/icons/calendar-arrow-left.svg');
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-months
  .flatpickr-next-month:after {
  background-image: url('#{$base-url}img/icons/calendar-arrow-right.svg');
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-calendar.multiMonth
  .flatpickr-days
  .dayContainer:nth-child(n + 2)
  .flatpickr-day.inRange:nth-child(7n + 1) {
  box-shadow:
    -2px 0 0 #fffaae,
    5px 0 0 #fffaae;
}

qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.selected.endRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.startRange.endRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.endRange.endRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.selected.startRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.startRange.startRange,
qw-calendar-picker.qw-calendar-picker--responsive
  .flatpickr-day.endRange.startRange {
  border-radius: 50%;
}

qw-calendar-picker.qw-calendar-picker--responsive {
  border-radius: 50%;
}

@media only screen and (max-width: 1280px) {
  qw-calendar {
    max-width: 970px;
    margin: 0 auto;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-prev-month,
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-next-month {
    top: 21px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-month {
    font-size: 18px;
    margin-bottom: 15px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive span.flatpickr-weekday {
    font-size: 14px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 45px;
    flex-basis: 45px;
    height: 45px;
    line-height: 45px;
    margin: 10px 10px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day.inRange:after {
    width: calc(100% + 24px);
    left: -11px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.startRange:after {
    width: 77%;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.endRange:before {
    width: 76%;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-current-month {
    font-size: 130%;
  }
}

@media only screen and (max-width: 1100px) {
  qw-calendar {
    max-width: 870px;
    margin: 0 auto;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 46px;
    flex-basis: 46px;
    height: 46px;
    line-height: 46px;
    margin: 10px 6px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-current-month {
    font-size: 120%;
  }
}

@media only screen and (min-width: 738px) and (max-height: 760px) {
  qw-calendar {
    max-width: 700px;
  }

  qw-calendar qw-calendar-picker {
    min-height: 408px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-month {
    font-size: 18px;
    margin-bottom: 15px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 44px;
    line-height: 44px;
    margin: 5px 0 0px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day.inRange:after {
    width: calc(100% + 2px);
    left: -1px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.startRange:after {
    width: 56%;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.endRange:before {
    width: 53%;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1280px) and (min-height: 760px) {
  qw-calendar.qw-calendar--modal {
    min-width: 970px;
  }
}
@media only screen and (min-width: 975px) and (max-width: 1100px) and (min-height: 760px) {
  qw-calendar.qw-calendar--modal {
    min-width: 870px;
  }
}
/* @media only screen and (min-width: 975px) and (max-width: 1100px) and (max-height: 760px) {
  qw-calendar {
    max-width: 700px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 44px;
    line-height: 44px;
    margin: 5px 0 0px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar span.flatpickr-day.inRange:after {
    width: calc(100% + 2px);
	  left: -1px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar .flatpickr-day.startRange:after {
    width: 56%;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar .flatpickr-day.endRange:before {
    width: 53%;
  }
} */

@media only screen and (max-width: 975px) {
  qw-calendar {
    max-width: 700px;
  }
  qw-calendar-picker .flatpickr-innerContainer {
    min-height: 0px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 44px;
    line-height: 44px;
    margin: 5px 0 0px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day.inRange:after {
    width: calc(100% + 2px);
    left: -1px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.startRange:after {
    width: 56%;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    .flatpickr-day.endRange:before {
    width: 53%;
  }
}

@media only screen and (max-width: 700px) {
  qw-calendar-picker .flatpickr-innerContainer {
    min-height: 0;
  }

  /* qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.nextMonthDay,
  qw-calendar-picker .flatpickr-calendar.inline .flatpickr-day.prevMonthDay {
    opacity: var(--qw-hotel-opacity);
    pointer-events: none !important;
  } */

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-month {
    font-size: 18px;
    margin-bottom: 24px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive span.flatpickr-weekday,
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    font-size: 15px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day.endRange.inRange:after {
    content: none;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar {
    padding-left: 16px;
    padding-right: 16px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .dayContainer {
    justify-content: space-between;
  }
}

@media only screen and (max-width: 340px) {
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    line-height: 280%;
  }
}

@media only screen and (max-width: 450px) {
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 52px;
    line-height: 52px;
    margin: 0;
    margin-top: 5px;
  }
}

@media only screen and (max-width: 376px) {
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 47px;
    line-height: 47px;
    margin: 0;
    margin-top: 5px;
  }
}

@media only screen and (max-width: 738px) {
  qw-calendar.qw-calendar--modal {
    max-width: 100%;
    width: 100%;
  }

  qw-calendar-picker.qw-calendar--modal.qw-calendar-picker--responsive
    .flatpickr-calendar {
    border-radius: 0;
    border: 0;
    border-top: 1px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  }

  qw-calendar.qw-calendar--modal .flatpickr-weekdays {
    background: var(--qw-hotel-neutral-light);
    height: 50px;
  }

  qw-calendar-picker.qw-calendar--modal.qw-calendar-picker--responsive
    span.flatpickr-weekday {
    font-family: var(--qw-hotel-font-family-l) !important;
    font-size: 16px !important;
    text-transform: capitalize;
  }

  qw-calendar-picker.qw-calendar--modal.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    height: 40px;
    width: 40px;
    line-height: 40px;
  }

  qw-calendar-picker.qw-calendar--modal.qw-calendar-picker--responsive
    .flatpickr-current-month {
    font-size: 21px;
  }
}

@media only screen and (max-width: 320px) {
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    width: 14.2857143%;
    flex-basis: 14.2857143%;
    height: 42px;
    line-height: 42px;
    margin: 0;
    margin-top: 5px;
  }
}

@media only screen and (max-width: 738px) {
  qw-calendar {
    max-width: 100%;
    width: 100%;
    z-index: 2;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar {
    border-radius: 0;
    border: 0;
    border-top: 1px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  }

  qw-calendar .flatpickr-weekdays {
    background: var(--qw-hotel-neutral-light);
    height: 50px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive span.flatpickr-weekday {
    font-family: var(--qw-hotel-font-family-l) !important;
    font-size: 16px !important;
    text-transform: capitalize;
  }

  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-calendar
    span.flatpickr-day {
    height: 40px;
    width: 40px;
    line-height: 40px;
  }

  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-current-month {
    font-size: 21px;
  }
}

@media only screen and (max-width: 440px) {
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-calendar {
    padding-left: 8px;
    padding-right: 8px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-month {
    margin-bottom: 8px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-next-month {
    right: 12px;
    width: 24px;
    height: 24px;
  }
  qw-calendar-picker.qw-calendar-picker--responsive
    .flatpickr-months
    .flatpickr-prev-month {
    left: 12px;
  }
  .flatpickr-current-month .flatpickr-monthDropdown-months {
    padding-left: 0;
  }
  qw-calendar-picker.qw-calendar-picker--responsive .flatpickr-current-month {
    font-size: 18px;
  }
}
